import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";

import {
  MatTableDataSource,
  MatPaginator,
  MatDialog,
} from "@angular/material";
import { ICompany } from "src/app/interfaces/company";
import { environment } from "src/environments/environment";
import { SendDocumentComponent } from "../send-document/send-document.component";
import { StudentService } from "src/app/services/http/business/student/student.service";
import { HidService } from "src/app/services/common/hid.service";
@Component({
  selector: 'app-student-documents',
  templateUrl: './student-documents.component.html',
  styleUrls: ['./student-documents.component.css']
})
export class StudentDocumentsComponent implements OnInit {
  param: any;
  isOwner: boolean;
  errObject: any;
  queryParams: any;
  errors = new Array();
  pageSize: number;
  pageIndex: number;
  companyList: ICompany;
  personDocumentList=[];
  companySelected: String;
  CompanyEncryptId: string;
  //filter: any;
  baseUrl= environment.BaaseUrl;

  displayedColumns: string[] = [

    "discountType",
    "file",
    "status",
    "function"
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    public translate: TranslateService,
    public hidService:HidService,
    private studentService:StudentService,

  ) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.queryParams = {
      holdingEncryptId : this.hidService.getHID()
    }
    this.refresh();
  }

  getColor(statusId) {
    switch (statusId) {
      case 151:
        return "custom-chips primary";
      case 150:
        return "custom-chips warn";
      case 152:
        return "custom-chips accent";
      default:
        return "custom-chips default";
    }
  }

  isAcceptedDocumentStatus(params: Array<any>) {
    params.forEach(element => {
      if (element.DocumentStatusId == 151) {
        element.IsAcceptedDocument = true;
      }
      else if (element.DocumentStatusId == 152) {
        element.IsAcceptedDocument = false;
      }

    });
  }
  convertStringToArray(items):any{
    items.forEach(element => {
      element.Files= JSON.parse(element.Files);
    });
  };

  refresh() {
    this.studentService.getPersonDocuments().subscribe(res => {

      this.isAcceptedDocumentStatus(res.DataList);
      this.convertStringToArray(res.DataList);
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 1;
      this.paginator.pageSize = 10;
      this.pageIndex = 0;
      this.pageSize = 10;
    });
  }

  paginatorEvent(event) {
    this.studentService.getPersonDocuments(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.isAcceptedDocumentStatus(res.DataList);
        this.convertStringToArray(res.DataList);
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
      });
  }

  add() {
    this.dialog.open(SendDocumentComponent,{
      width:"600px"
    })
      .afterClosed()
      .subscribe(() => {
        this.refresh();
      });
  }

  edit(element: any) {

    this.dialog.open(SendDocumentComponent, {
      width:"350px",
      data: element
    })
      .afterClosed().subscribe(() => {
        this.refresh();
      });
  }

}
